import { Box, Stack } from '@mui/material';

import { Button, Modal, Separator, Typography } from '@/design-system';
import { colors } from '@/shared/design-system/colors';

import { fmtAmount, fmtUsd } from './formatters';
import { CoinModalProps } from './types';

export const CollateralizeModal = ({ open, onClose, coin }: CoinModalProps) => (
  <Modal
    open={open}
    onOpenChange={(next) => {
      if (!next) onClose();
    }}
    title={`Collateralize ${coin.symbol}`}
    showClose
    maxWidth={440}
  >
    <Stack gap="24px" flexDirection="column">
      <Separator tone="subtle" />
      <Box bgcolor="#1E2333" border="1px solid #2E3348" borderRadius="10px" p="16px">
        <Stack gap="12px">
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body4" color={colors.text.secondary}>
              Asset
            </Typography>
            <Typography variant="body4">{coin.symbol}</Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body4" color={colors.text.secondary}>
              Balance
            </Typography>
            <Typography variant="body4">
              {fmtAmount(coin.balance)} {coin.symbol}
            </Typography>
          </Stack>
          {coin.usdValue != null && (
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="body4" color={colors.text.secondary}>
                Present Value
              </Typography>
              <Typography variant="body4">{fmtUsd(coin.usdValue)}</Typography>
            </Stack>
          )}
          <Separator tone="subtle" />
          <Typography variant="body4" color={colors.text.secondary}>
            Use {coin.symbol} as collateral to access liquidity without selling your position.
          </Typography>
        </Stack>
      </Box>
      <Stack gap="12px">
        <Button size="lg" onClick={onClose}>
          Collateralize {coin.symbol}
        </Button>
        <Button color="secondary" variant="subtle" size="lg" onClick={onClose}>
          Cancel
        </Button>
      </Stack>
    </Stack>
  </Modal>
);
